import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAnswer = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Answer",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip-path",
		children: /* @__PURE__ */ _jsx("rect", {
			id: "Rectangle_981",
			"data-name": "Rectangle 981",
			width: 24,
			height: 24,
			transform: "translate(-8015 7135)",
			fill: "#fff",
			stroke: "#707070",
			strokeWidth: 1
		})
	}) }), /* @__PURE__ */ _jsx("g", {
		id: "Icon_Answer",
		"data-name": "Icon/Answer",
		transform: "translate(8015 -7135)",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "Group_897",
			"data-name": "Group 897",
			transform: "translate(-8010.286 7137.143)",
			children: [
				/* @__PURE__ */ _jsx("rect", {
					id: "Rectangle_980",
					"data-name": "Rectangle 980",
					width: 13.714,
					height: 12,
					transform: "translate(0.637)",
					fill: "#fea627"
				}),
				/* @__PURE__ */ _jsx("line", {
					id: "Line_146",
					"data-name": "Line 146",
					y2: 12,
					transform: "translate(4.065)",
					fill: "none",
					stroke: "#f7cc8e",
					strokeWidth: 1
				}),
				/* @__PURE__ */ _jsx("line", {
					id: "Line_147",
					"data-name": "Line 147",
					y2: 12,
					transform: "translate(7.494)",
					fill: "none",
					stroke: "#f7cc8e",
					strokeWidth: 1
				}),
				/* @__PURE__ */ _jsx("line", {
					id: "Line_148",
					"data-name": "Line 148",
					y2: 12,
					transform: "translate(10.922)",
					fill: "none",
					stroke: "#f7cc8e",
					strokeWidth: 1
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_807",
					"data-name": "Path 807",
					d: "M4.849,4.849,9.7,0l.9,10.6L0,9.7Z",
					transform: "translate(7.494 5.143) rotate(45)",
					fill: "#f7e8c3"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_808",
					"data-name": "Path 808",
					d: "M1.319,1.319,2.638,0l.245,2.883L0,2.638Z",
					transform: "translate(7.494 16.053) rotate(45)",
					fill: "#253435"
				})
			]
		})
	})]
});
export default SvgAnswer;
